
export const mockSites =
    [
        {
            "City": "N.A",
            "Country": "Worldwide",
            "Description ": "User uploaded images ",
            "ID": "0",
            "Path": "site0.json",
            "Site": "Custom Images "
        },
        {
            "City": "Iran",
            "Country": "Iran",
            "Description ": "Airbase in Iran",
            "ID": "1",
            "Path": "site1.json",
            "Site": "Shiraz Airbase"
        },
        {
            "City": "Iraq",
            "Country": "Iraq",
            "Description ": "Airbase in Iraq",
            "ID": "2",
            "Path": "site2.json",
            "Site": "Al Asad Airbase "
        }
    ]

export const mockAircrafts =
    [
        {
            "ID": "0",
            "Images": "0.jpg",
            "Name": "C130 Hercules ",
            "Reference": "By U.S. Air Force photo by Tech. Sgt. Howard Blair #30865"
        },
        {
            "ID": "1",
            "Images": "1.jpg",
            "Name": "Su-24 (Fencer) ",
            "Reference": "By Alexander Mishin #17095565"
        },
        {
            "ID": "2",
            "Images": "2.jpg",
            "Name": "IL-76 Ilyushin (Candid) ",
            "Reference": "By Alexey Reznichenko #54888337"
        },
        {
            "ID": "3",
            "Images": "3.jpg",
            "Name": "Pilatus PC-6 porter ",
            "Reference": " \"By Gully #35585535\""
        },
        {
            "ID": "4",
            "Images": "4.jpg",
            "Name": "Lockheed P3 Orion ",
            "Reference": "By \u6d77\u4e0a\u81ea\u885b\u968a #62312428"
        },
        {
            "ID": "5",
            "Images": "5.jpg",
            "Name": "Sukhoi 22 Fitter ",
            "Reference": "By Chris Lofting #17190161"
        },
        {
            "ID": "6",
            "Images": "6.jpg",
            "Name": "Fokker 100 ",
            "Reference": "By Laurent ERRERA from L'Union, France #29837300"
        },
        {
            "ID": "7",
            "Images": "7.jpg",
            "Name": "MIL Mi-8 / 17 Hip ",
            "Reference": "By Igor Dvurekov #77758171"
        },
        {
            "ID": "8",
            "Images": "8.jpg",
            "Name": "BAE 146 ",
            "Reference": " \"By Photo: Sgt Jack Pritchard #26905722\""
        },
        {
            "ID": "9",
            "Images": "9.jpg",
            "Name": "Harbin Y-12 ",
            "Reference": " \"By Alan Lebeda #21644818"
        },
        {
            "ID": "10",
            "Images": "10.jpg",
            "Name": "Boeing 737 ",
            "Reference": "By Montague Smithderivative #60250243"
        },
        {
            "ID": "11",
            "Images": "11.jpg",
            "Name": "Fokker F27 / 50 ",
            "Reference": " \"By Teemu Pesonen #17292316\""
        },
        {
            "ID": "12",
            "Images": "12.jpg",
            "Name": "Bombardier Canadair CRJ100/200 ",
            "Reference": " \"By ERIC SALARD #72471635\""
        },
        {
            "ID": "13",
            "Images": "13.jpg",
            "Name": "Airbus A300 ",
            "Reference": "By Kambui #58134967"
        },
        {
            "ID": "14",
            "Images": "14.jpg",
            "Name": "Unknown ",
            "Reference": "default"
        },
        {
            "ID": "15",
            "Images": "15.jpg",
            "Name": "AN-74 Coaler ",
            "Reference": "By Dmitry A. Mottl #4877526"
        },
        {
            "ID": "16",
            "Images": "16.jpg",
            "Name": "Dassault Falcon 20 (Probable) ",
            "Reference": "By Peter Bakema  #31206125"
        },
        {
            "ID": "17",
            "Images": "17.jpg",
            "Name": "Airbus A340 ",
            "Reference": "By Iberia Airlines #35248558"
        },
        {
            "ID": "18",
            "Images": "18.jpg",
            "Name": "background ",
            "Reference": "default"
        }
    ]


export const mockImages = [
    {
        "Date": "04/05/2022",
        "Geojson": "20220504_101705_ssc10_u0001_analytic_SR_clip.geojson",
        "ID": "1",
        "Site": "1"
    },
    {
        "Date": "12/07/2023",
        "Geojson": "20230712_061757_ssc4_u0001_analytic_SR_clip.geojson",
        "ID": "2",
        "Site": "1"
    },
    {
        "Date": "25/07/2023",
        "Geojson": "20230725_124240_ssc9_u0003_pansharpened_clip.tif.geojson",
        "ID": "3",
        "Site": "1"
    },
    {
        "Date": "07/08/2023",
        "Geojson": "20230807_123337_ssc10_u0001_analytic_SR_clip.geojson",
        "ID": "4",
        "Site": "1"
    },
    {
        "Date": "08/08/2023",
        "Geojson": "20230808_075305_ssc2_u0001_analytic_SR_clip.tif.geojson",
        "ID": "5",
        "Site": "1"
    },
    {
        "Date": "16/08/2023",
        "Geojson": "20230816_075344_ssc2_u0001_analytic_SR_clip.tif.geojson",
        "ID": "6",
        "Site": "1"
    },
    {
        "Date": "16/08/2023",
        "Geojson": "20230816_123839_ssc6_u0001_analytic_SR_clip.tif.geojson",
        "ID": "7",
        "Site": "1"
    },
    {
        "Date": "21/08/2023",
        "Geojson": "20230821_122930_ssc9_u0001_analytic_SR_clip.tif.geojson",
        "ID": "8",
        "Site": "1"
    },
    {
        "Date": "31/08/2023",
        "Geojson": "20230831_130358_ssc6_u0001_analytic_SR_clip.tif.geojson",
        "ID": "9",
        "Site": "1"
    },
    {
        "Date": "07/09/2023",
        "Geojson": "20230907_055712_ssc2_u0001_analytic_SR_clip.geojson",
        "ID": "10",
        "Site": "1"
    },
    {
        "Date": "12/09/2023",
        "Geojson": "20230912_060554_ssc2_u0001_analytic_SR_clip.geojson",
        "ID": "11",
        "Site": "1"
    },
    {
        "Date": "01/10/2023",
        "Geojson": "20231001_103712_ssc10_u0001_analytic_SR_clip.geojson",
        "ID": "12",
        "Site": "1"
    },
    {
        "Date": "12/10/2023",
        "Geojson": "20231012_055828_ssc2_u0001_analytic_SR_clip.geojson",
        "ID": "13",
        "Site": "1"
    },
    {
        "Date": "16/10/2023",
        "Geojson": "20231016_103306_ssc8_u0001_analytic_SR_clip.geojson",
        "ID": "14",
        "Site": "1"
    }
]

export const mockImagesTree =  [ { "id": "Y_0", "label": "2022", "children": [ { "id": "M_Y_0-0", "label": "May 2022", "children": [ { "id": "D_M_Y_0-0-0", "label": "4 May 2022", "children": [ { "id": "1", "label": "20220504_101705_ssc10_u0001_analytic_SR_clip.geojson" } ] } ] } ] }, { "id": "Y_1", "label": "2023", "children": [ { "id": "M_Y_1-0", "label": "July 2023", "children": [ { "id": "D_M_Y_1-0-0", "label": "12 July 2023", "children": [ { "id": "2", "label": "20230712_061757_ssc4_u0001_analytic_SR_clip.geojson" } ] }, { "id": "D_M_Y_1-0-1", "label": "25 July 2023", "children": [ { "id": "3", "label": "20230725_124240_ssc9_u0003_pansharpened_clip.tif.geojson" } ] } ] }, { "id": "M_Y_1-1", "label": "August 2023", "children": [ { "id": "D_M_Y_1-1-0", "label": "7 August 2023", "children": [ { "id": "4", "label": "20230807_123337_ssc10_u0001_analytic_SR_clip.geojson" } ] }, { "id": "D_M_Y_1-1-1", "label": "8 August 2023", "children": [ { "id": "5", "label": "20230808_075305_ssc2_u0001_analytic_SR_clip.tif.geojson" } ] }, { "id": "D_M_Y_1-1-2", "label": "16 August 2023", "children": [ { "id": "6", "label": "20230816_075344_ssc2_u0001_analytic_SR_clip.tif.geojson" }, { "id": "7", "label": "20230816_123839_ssc6_u0001_analytic_SR_clip.tif.geojson" } ] }, { "id": "D_M_Y_1-1-3", "label": "21 August 2023", "children": [ { "id": "8", "label": "20230821_122930_ssc9_u0001_analytic_SR_clip.tif.geojson" } ] }, { "id": "D_M_Y_1-1-4", "label": "31 August 2023", "children": [ { "id": "9", "label": "20230831_130358_ssc6_u0001_analytic_SR_clip.tif.geojson" } ] } ] }, { "id": "M_Y_1-2", "label": "September 2023", "children": [ { "id": "D_M_Y_1-2-0", "label": "7 September 2023", "children": [ { "id": "10", "label": "20230907_055712_ssc2_u0001_analytic_SR_clip.geojson" } ] }, { "id": "D_M_Y_1-2-1", "label": "12 September 2023", "children": [ { "id": "11", "label": "20230912_060554_ssc2_u0001_analytic_SR_clip.geojson" } ] } ] }, { "id": "M_Y_1-3", "label": "October 2023", "children": [ { "id": "D_M_Y_1-3-0", "label": "1 October 2023", "children": [ { "id": "12", "label": "20231001_103712_ssc10_u0001_analytic_SR_clip.geojson" } ] }, { "id": "D_M_Y_1-3-1", "label": "12 October 2023", "children": [ { "id": "13", "label": "20231012_055828_ssc2_u0001_analytic_SR_clip.geojson" } ] }, { "id": "D_M_Y_1-3-2", "label": "16 October 2023", "children": [ { "id": "14", "label": "20231016_103306_ssc8_u0001_analytic_SR_clip.geojson" } ] } ] } ] } ]
export const mockOutcome = [
    {
        "Class_ID": "10",
        "Class_Name": "Boeing 737",
        "Confidence": "0.7984814047813416",
        "Date": "08/08/2023",
        "Filename": "20230808_075305_ssc2_u0001_analytic_SR_clip.tif.geojson",
        "Master_Serial#": "128",
        "Serial#": "1"
    },
    {
        "Class_ID": "11",
        "Class_Name": "Fokker F27 / 50",
        "Confidence": "0.5463529229164124",
        "Date": "08/08/2023",
        "Filename": "20230808_075305_ssc2_u0001_analytic_SR_clip.tif.geojson",
        "Master_Serial#": "129",
        "Serial#": "2"
    },
    {
        "Class_ID": "6",
        "Class_Name": "Fokker 100",
        "Confidence": "0.3101944029331207",
        "Date": "08/08/2023",
        "Filename": "20230808_075305_ssc2_u0001_analytic_SR_clip.tif.geojson",
        "Master_Serial#": "130",
        "Serial#": "3"
    }
]
export const mockHistory = [
    {
        "Class_ID": "10",
        "Class_Name": "Boeing 737",
        "Confidence": "0.7984814047813416",
        "Date": "08/08/2023",
        "Filename": "20230808_075305_ssc2_u0001_analytic_SR_clip.tif.geojson",
        "Master_Serial#": "128",
        "Serial#": "1"
    },
    {
        "Class_ID": "11",
        "Class_Name": "Fokker F27 / 50",
        "Confidence": "0.5463529229164124",
        "Date": "08/08/2023",
        "Filename": "20230808_075305_ssc2_u0001_analytic_SR_clip.tif.geojson",
        "Master_Serial#": "129",
        "Serial#": "2"
    },
    {
        "Class_ID": "6",
        "Class_Name": "Fokker 100",
        "Confidence": "0.3101944029331207",
        "Date": "08/08/2023",
        "Filename": "20230808_075305_ssc2_u0001_analytic_SR_clip.tif.geojson",
        "Master_Serial#": "130",
        "Serial#": "3"
    }
]